import { PropertySection } from "./property-sections";
import { ComponentKind, TableColumn, MutatingScreenKind, makeEmptyComponentDescription } from "../description";
import {
    SimpleComponentHandler,
    SimplePrimitiveColumnPropertyHandler,
    SimpleComponentDescription,
} from "./simple-handler";
import { AudioPlayerUI } from "../../components/uis";
import { makeTextPropertyDescriptor } from "./descriptor-utils";

const ComponentKindAudioPlayer: ComponentKind = "audio-player";

const audioProperty = new SimplePrimitiveColumnPropertyHandler({
    name: "propertyName",
    label: "Audio",
    preferredType: "audio-uri",
    mustBeString: true,
    preferredNames: ["audio", "sound", "mp3"],
    section: PropertySection.Data,
});

export class AudioPlayerComponentHandler extends SimpleComponentHandler {
    constructor() {
        super({
            kind: ComponentKindAudioPlayer,
            name: "Audio",
            group: "Media",
            description: "Play an audio file from a link",
            img: "componentAudio",
            uiClass: AudioPlayerUI,
            helpPath: "audioPlayer",
        });
    }

    protected getPropertyDescriptors(
        _desc: SimpleComponentDescription,
        mutatingScreenKind: MutatingScreenKind | undefined
    ) {
        return [
            {
                descriptor: () =>
                    makeTextPropertyDescriptor("propertyName", "Audio", "Enter URL", true, mutatingScreenKind, {
                        preferredType: "audio-uri",
                        preferredNames: ["audio", "sound", "mp3"],
                        searchable: false,
                        columnFirst: true,
                    }),
                argumentName: "audio",
            },
        ];
    }
}

export function defaultAudioComponent(column: TableColumn): SimpleComponentDescription {
    return audioProperty.setInDescription(
        { ...makeEmptyComponentDescription(ComponentKindAudioPlayer), actions: undefined },
        column.name
    );
}
